import React, { useEffect, useState } from "react";
import "./PaymentReceivedChart.scss";
import { Chart } from "chart.js";
import { PAYMENT_RECEIVED_CHART_DATA } from "./PaymentReceivedChart.data";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";

const PaymentReceivedChart: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPaymentReceivedDetails();
  }, []);

  const getPaymentReceivedDetails = async () => {
    try {
      setLoading(true);
      const { data } = await ApiService().client.get(
        URLS.DASHBOARD.PAYMENT_RECEIVED_DETAILS
      );
      setTimeout(() => {
        paymentReceivedConsumptionRender(data.data.key, data.data.months);
      }, 100);
    } catch (err) {
      console.error("Error: Getting Information on payment received ", err);
    } finally {
      setLoading(false);
    }
  };

  const paymentReceivedConsumptionRender = async (
    data: number[],
    months: string[]
  ) => {
    await clearPaymentReceivedChart();
    const canvas = document.getElementById(
      "payment-received-chart"
    ) as HTMLCanvasElement;

    if (!canvas) return;

    canvas.setAttribute("height", `${10 * 18 + 10}px`);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    gradient.addColorStop(0, "#FDCD08");
    gradient.addColorStop(1, "#F5F27D");

    const maxValue = Math.max(...data);
    const stepCount = 5;
    const yAxisMax = Math.ceil(maxValue / stepCount / 1000) * 1000 * stepCount; // optional: round to nearest 1000
    const stepSize = yAxisMax / stepCount;

    const chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: months,
        datasets: [
          {
            label: "Payments",
            data,
            backgroundColor: data.map((v) => (v === 0 ? "#f5f5f5" : gradient)),
            barThickness: 10,
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 10,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            min: 0,
            max: yAxisMax,
            beginAtZero: true,
            ticks: {
              stepSize: stepSize,
              padding: 12,
              color: "#33333399",
              font: {
                size: 12,
                weight: 500,
                family: "Inter",
              },
              callback: function (tickValue: string | number) {
                if (typeof tickValue === "number") {
                  return tickValue.toLocaleString("en-IN");
                }
                return tickValue;
              },
            },
            grid: {
              display: true,
              color: "#E5E7EB",
            },
            border: {
              display: false,
            },
          },
          x: {
            offset: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "#333333",
              font: {
                size: 12,
                lineHeight: 1.5,
                weight: 500,
                family: "Inter",
              },
            },
          },
        },
      },
    });
  };

  const clearPaymentReceivedChart = async () => {
    const chartStatus = Chart.getChart("payment-received-chart"); // <canvas> id
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }
  };

  return (
    <div className="payment-received-chart-main-chart-container py-12 px-8 flex-column gap-16 flex-1">
      <p className="xetgo-font-tag bold heading">Payments Received</p>
      {!loading ? (
        <div className="vendor-graph-container">
          <canvas id="payment-received-chart"></canvas>
        </div>
      ) : (
        <div className="empty-state-payment-recieved-detail flex-row align-items-center justify-content-center">
          <div className="mini-loader">{loading}</div>
        </div>
      )}
    </div>
  );
};

export default PaymentReceivedChart;
